import { BCCustomTag } from "src/shared/styled/global.styled";

const BCTag = ({ status }: any) => {
    return(
        <BCCustomTag className={`bc-custom-tag ${status === 'COMPLETE' ? 'success' : 'progress'}`}>
            <span className="tag-circle"></span>
            <span className="tag-label">{status === 'COMPLETE' ? 'Completado' :  'En Progreso'}</span>
        </BCCustomTag>)
}

export default BCTag;